import React, { useEffect, createElement } from 'react';
import { Hero } from './components/sections/Hero';
import { Testimonials } from './components/sections/Testimonials';
import { PainPoints } from './components/sections/PainPoints';
import { ProductTomos } from './components/sections/ProductTomos';
import { Bonuses } from './components/sections/Bonuses';
import { CountdownTimer } from './components/sections/CountdownTimer';
import { Pricing } from './components/sections/Pricing';
import { MicroFabrica } from './components/sections/MicroFabrica';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { ComparisonTable } from './components/sections/ComparisonTable';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { SocialProofToast } from './components/ui/SocialProofToast';
export function App() {
  useEffect(() => {
    // Meta Pixel - injected directly via script tag (official approach)
    const pixelId = '2411207615977952';
    if (!(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    ;
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-sans selection:bg-amber selection:text-wood-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <ProductTomos data-id="element-3" />
      <Bonuses data-id="element-4" />
      <Testimonials data-id="element-5" />
      <CountdownTimer data-id="element-6" />
      <Pricing data-id="element-7" />
      <MicroFabrica data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <ComparisonTable data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <Footer data-id="element-13" />
      <SocialProofToast data-id="element-14" />
    </div>;
}